import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
//mixin
// import ModalMixin from "@/mixin/ModalMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js"
import LocaleMixin from "@/mixin/LocaleMixin.js";
import Locale from '@/helper/locale/locale.js';
//helper
import Account from "@/helper/AccountHelper.js";
// import CacheHelper from "@/helper/CacheHelper.js";
// import Util from "@/helper/Utility.js";
export default {
    mixins: [AccountMixin, LocaleMixin],
    // components: {
    //     ModalMaster
    // },
    data: function () {
        return {
            token: null,
            dataUserPdpa: null,
            termsVersion: null,
            privacyVersion: null,
            ageVersion: null,
            marketingVersion: null,
            consentPrivacy: null,
            consentTerms: null,
            consentAge: null,
            consentMarketing: null,
            marketingReConsent: {
                email: null,
                sms: null,
                line: null,
                notification: null
            },
            page: null,
            isAcceptMarketing: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function () {
        // this.initialOtherModal();
        // this.getPDPAConsent();
    },
    methods: {
        checkPdpa: async function(page) {
            this.token = Account.getToken();
            this.page = page;
            var currentVersion = await this.getPdpaVersion();

            //user consent
            var userConsentVersion = await this.checkUserConsentVersion();
            var userTerm = userConsentVersion.terms ? userConsentVersion.terms : 0;
            var userPrivacy = userConsentVersion.privacy ? userConsentVersion.privacy : 0;
            var userMarketing = userConsentVersion.marketing ? userConsentVersion.marketing : 0;
            // var userAge = userConsentVersion.age ? userConsentVersion.age : 0;
            var needSaveConsent = false;

            if (userTerm != currentVersion.terms && userPrivacy != currentVersion.privacy) {
                await this.openTermsConsent();
                needSaveConsent = true;
            }

            if (userMarketing != currentVersion.marketing) {
                await this.openMarketingConsent();
                needSaveConsent = true;
            }
            
            // if (userAge != currentVersion.age) {
            //     await this.openAgeConsent();
            //     needSaveConsent = true;
            // }

            if (needSaveConsent) {
                await this.submitConsent();
            }
        },
        checkUserConsentVersion: function() {
            return new Promise((resolve, reject) => {
                PDPAService.apiGetUserPDPA(this.token).then((data) => {
                    this.dataUserPdpa = data.data;
                    this.consentPrivacy = this.dataUserPdpa.DataPrivacy;
                    this.consentTerms = this.dataUserPdpa.TermAndCondition;
                    this.consentAge = this.dataUserPdpa.ConsentAge;
                    this.consentmarketing = this.dataUserPdpa.MarketingOption;
                    this.marketingReConsent = {
                        email: this.dataUserPdpa.EmailMarketing,
                        sms: this.dataUserPdpa.SMSMarketing,
                        line: this.dataUserPdpa.LineMarketing,
                        // notification: this.dataUserPdpa.NotificationMarketing
                    }
                        resolve({
                            terms: this.consentTerms,
                            privacy: this.consentPrivacy,
                            marketing: this.consentmarketing,
                            marketingReConsent: this.marketingReConsent,
                            age: this.consentAge
                        });
                }, (err) => {
                    console.log(err)
                    reject(err);
                });
            });
        },
        getPdpaVersion: function() {
            return new Promise((resolve, reject) => {
                PDPAService.apiGetPDPAVersion(this.token).then((data) => {
                    this.termsVersion = data.data.terms.current_version;
                    this.privacyVersion = data.data.privacy.current_version;
                    this.marketingVersion = data.data.marketing.current_version;
                    this.ageVersion = data.data.age;

                        resolve({
                            terms: this.termsVersion,
                            privacy: this.privacyVersion,
                            marketing: this.marketingVersion,
                            age: this.ageVersion
                        });
                }, (err) => {
                    console.log(err)
                    reject(err);
                });
            });
        },
        openTermsConsent: function(){
            return new Promise((resolve) => {
                this.termsModal.setTag('accept-terms')
                                .setTitle(this.lbl.register.terms_headline_modal)
                                .setBtnAcceptTerms(this.lbl.btn_accept)
                                .show();
                this.termsModal.onAcceptTerms((data) => {
                    if (data.tag == 'accept-terms') {
                        resolve();
                    }
                });
            });
        },
        openMarketingConsent: async function(){
            return new Promise((resolve) => {
                this.marketingRegisterModal.clearText()
                                            .setTag('accept-marketing')
                                            .setTitle(this.lbl.marketing.title)
                                            .setBtnAcceptMarketing(this.lbl.btn_accept)
                                            .show();
                this.marketingRegisterModal.onAcceptMarketing((data)=> {
                    if(data.accept){
                        this.marketingReConsent.email = data.marketing.email;
                        this.marketingReConsent.sms = data.marketing.sms;
                        this.marketingReConsent.line = data.marketing.line;
                        // this.marketingReConsent.notification = data.marketing.notification;
                        resolve();
                    }
                });
                this.marketingRegisterModal
                    .onAcceptConfirmMarketing((data)=> {
                        if(data){
                            this.marketingRegisterModal
                                .clearText()
                                .setTag('accept-marketing')
                                .setTitle(this.lbl.marketing.title)
                                .setBtnAcceptMarketing(this.lbl.btn_accept)
                                .show();
                        }
                    });
                this.marketingRegisterModal
                    .onCancelMarketing((data)=> {
                        if(data){
                            this.isAcceptMarketing = false;
                            resolve();
                        }
                    });
            });
        },
        openAgeConsent: function(){
            return new Promise((resolve) => {
                this.ageConsentModal.show();
                this.ageConsentModal.onAcceptAge((data) => {
                    if (data) {
                        resolve();
                    }
                })
            });
        },
        submitConsent: function(){
            //Save Consent
            // var token = this.getToken();
            let consentModel = new PDPAModel();
            var consent = {
                termandcondition: this.termsVersion,
                dataprivacy: this.privacyVersion,
                consentAge: 20,
                email: this.marketingReConsent.email,
                sms: this.marketingReConsent.sms,
                // notification: this.marketingReConsent.notification,
                line: this.marketingReConsent.line,
                marketingOption: this.marketingVersion
            }
            consentModel.setPDPAModel(consent);
            let params = consentModel.getParams();
            return new Promise((resolve) => {
                PDPAService.apiUpdateUserPDPA(this.token, params).then((data) => {
                    console.log(data);
                    if (this.page) {
                        this.$router.push('/home');
                    }
                    resolve(data);
                }).catch((err) => {
                    this.errorResponse(err, this.errorHandler);
                    resolve(null);
                })
            });
        },
    }
}
